<script>
import {required} from "vuelidate/lib/validators";  
import store from "@/state/store"; 
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrRisk from "@/models/StrRisk";
import AddEdit3 from "../StrRiskGiris/AddEdit.vue";
import StrRiskGiris from "@/models/StrRiskGiris";
import moment from 'moment' 
export default {
  mixins: [Api, Sabit,StrRisk,StrRiskGiris],
  page: {
    title: "Risk Değerlendirme",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Drawer,
    Layout,
    PageHeader,
    formcombobox,
    BirimSecimi,
    AddEdit3,
  },
  data() {
    return {
      title: this.$t("StrRiskDeger.Title"),
      items: [
        {
          text: this.$t("StrRiskDeger.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrRiskDeger.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrRiskDeger.Title"),
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      bugun: null,
      FilitrelemePenceresi: true,
      TableData: [],
      RiskPuanlar:[],
      KriterTablosu:[],
      SecilenEtki:[],
      SecilenOlasilik:[],
      GerceklesmeDonemleri:[],
      EskiDonem: [],
      EskiDonemBitTarih: null,
      FormTitle: "",
      Userid:null,
      UserEmail:null,
      Personelid:null,
      BirimAdi: "",
      CevapTipi: "",
      RiskeVerilenCevap: "",
      RiskOylamaBirimYetkiliPersonel: [],
      Filter: {
        UstDonemId: "",
        DonemId: "",
        AmacId: "",
        BirimId: null,
        Risktipi:"",
        BaslamaTarihi:null,
        BitisTarihi:null
      },
      PageToplu: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      UstDonemIdComboBox: [],
      DonemIdComboBox: [],
      AmacIdComboBox: [],
      BirimIdCombobox: [],
      RiskDegerleri: [],
      RiskOldGiris: [],
      GeciciVeri: "",
      DataUpdate:"",
      StrRiskDeger2: [],
      AddEdit: "",
      SecilenGerceklesme: {},
      AltDonem: "",
      Donem: "",
      sayac:0,
    };
  },
  validations: {
    Filter: {
      UstDonemId: {required},
      DonemId: {required},
      AmacId: {},
      BirimId: {required},
      Risktipi:{required},
      BaslamaTarihi:{},
      BitisTarihi:{}
    },
  },
  methods: {
    Get() {
      let Page = {
      PageNumber: "1",
      PageSize: "9999",
      }; 
      this.ActionsFilterGet({ Service: "StrRiskDeger", Page: Page, Filter: "&DonemId=" + this.Filter.DonemId}).then((res) => {
            this.StrRiskDeger2 = res.Data;

          });
    },
    DonemBaslamaTarihi(Donemid){
      this.SecilenGerceklesme = this.DonemIdComboBox.filter((notification) =>
        notification.Id.includes(Donemid)
      )[0];

    },
    async Yenile(){

      await new Promise(resolve => setTimeout(resolve, 2000));
        this.FilterGet();
    },
    BirOncekiDonem(){

      let Page = {
      PageNumber: "1",
      PageSize: "9999",
      }; 
      this.EskiDonem=[];
      this.ActionsSingleGet({
                Service: "strperfdonem",
                Id: this.Filter.DonemId,
              }).then((res) => {
                this.EskiDonemBitTarih = (res.Data.YilBit - 1).toString(); 

      let Filter ="&UstId="+this.Filter.UstDonemId+"&Approval=true&Asc=Aciklama"+"&Yilbit="+this.EskiDonemBitTarih+"&VeriTipi=3"
      this.ActionsFilterGet({Service:"StrPerfDonem", Page:Page,Filter:Filter}).then((res) => {
              this.EskiDonem = res.Data;
              this.FilterGet();
          
      }); 
      });
      },
    FilterGet(){
     
      this.bugun = new Date();

      for (var i=0;i<this.GerceklesmeDonemleri.length;i++){
   
        if (this.Filter.DonemId==this.GerceklesmeDonemleri[i].Id){
       
          this.Filter.BaslamaTarihi=this.GerceklesmeDonemleri[i].BaslamaTarihi;
          this.Filter.BitisTarihi=this.GerceklesmeDonemleri[i].BitisTarihi;
        }

      }

      this.$v.$touch();
      if (!this.$v.$invalid) { 
          let Filter ="&Asc=Risk"
          if(this.Filter.Risktipi!=null && this.Filter.Risktipi!="")
          Filter=Filter+"&Risktipi=" +this.Filter.Risktipi;
          if(this.Filter.UstDonemId!=null && this.Filter.UstDonemId!="")
          Filter=Filter+"&DonemId=" +this.Filter.UstDonemId;
          if(this.Filter.BirimId!=null && this.Filter.BirimId!="")
          Filter=Filter+"&BirimId=" +this.Filter.BirimId;
          if(this.EskiDonem.length > 0){
            Filter=Filter+"&OncekiDonemId=" +this.EskiDonem[0].Id;
          }
           
          this.ActionsFilterGet({Service:"StrRisk", Page:this.Page, Filter:Filter}).then((res) => {
              if(res){
                this.TableData = [];
              for (var i = 0; i < res.Data.length; i++) {
                if((this.$options.filters.formatDate(this.SecilenGerceklesme.BaslamaTarihi) <= this.$options.filters.formatDate(res.Data[i].Created) && this.$options.filters.formatDate(res.Data[i].Created)  <= this.$options.filters.formatDate(this.SecilenGerceklesme.BitisTarihi)) || (this.$options.filters.formatDate(this.SecilenGerceklesme.BaslamaTarihi) >= this.$options.filters.formatDate(res.Data[i].Created))){   
                        console.log(res.Data[i])
                        this.TableData.push(res.Data[i]);
             
                }
              }
          

                  this.ActionsGet({Service:"StrRiskPuanlar", Page:this.Page}).then((puanlar) => {
                      if(puanlar){

                            this.RiskPuanlar = puanlar.Data;



                            this.Page.PageDataSize = res.TotalCount;
                            
                            for (var i=0;i<this.TableData.length;i++){

                              this.TableData[i].RiskPuanlar=[];

                              for (var s=0; s<this.RiskPuanlar.length; s++){

                                if (this.TableData[i].Riskpuanid==this.RiskPuanlar[s].Ustid){

                                    this.TableData[i].RiskPuanlar.push(this.RiskPuanlar[s]);
                        

                                }

                              }

                            }

                      
                      }

                  });

              }   

            this.RiskDegerGet();
          });
         
      }


    },
    RiskDegerGet(){ 
          let Page = {
          PageNumber: "1",
          PageSize: "9999",
          };

         let Filter = "&DonemId=" +this.Filter.DonemId + "&BirimId=" +this.Filter.BirimId+ "&PersonelId="+this.Personelid;
       
          this.ActionsFilterGet({Service:"StrRiskDeger", Page:Page, Filter:Filter}).then((res) => {
         
              this.RiskDegerleri = res.Data;
             
          });
    },

     DonemSec(){  
      let Page = {
      PageNumber: "1",
      PageSize: "9999",
      }; 
      this.DonemIdComboBox=[];
      let Filter ="&UstId="+this.Filter.UstDonemId+"&Approval=true&Asc=Aciklama"
      this.ActionsFilterGet({Service:"StrPerfDonem", Page:Page,Filter:Filter}).then((res) => {
      this.GerceklesmeDonemleri=res.Data;
      for (var i = 0; i < res.Data.length; i++) {
        this.DonemIdComboBox.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Aciklama,
          YilBas: res.Data[i].YilBas,
          BaslamaTarihi: res.Data[i].BaslamaTarihi,
          BitisTarihi: res.Data[i].BitisTarihi
        }); 
      }
      }); 
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },

    FilterRiskDegerEtki(RiskId) {
      let Filter = this.RiskDegerleri.filter((notification) =>
        notification.Riskid.includes(RiskId)
      )[0];
      if (Filter) {
        return Filter.Etki;
      } else {
        return;
      }
    },
    
    FilterRiskDegerOlasilik(RiskId) {
      let Filter = this.RiskDegerleri.filter((notification) =>
        notification.Riskid.includes(RiskId)
      )[0];
      if (Filter) {
        return Filter.Olasilik;
      } else {
        return;
      }
    },

    FilterRiskDeger(RiskId,PersonelId) {
      let Filter = this.RiskDegerleri.filter((notification) =>notification.Riskid.includes(RiskId));
      Filter = Filter.filter((notification) =>notification.Personelid.includes(PersonelId))[0];


      if (Filter) {
        return Filter;
      } else {
        return;
      }
    },

    RiskDegerGiris(RiskId, Value, Islem, Birimid, Donemid) {

          let riskpuanid=JSON.parse(Value).Id;
          let riskpuandeger=JSON.parse(Value).Deger;

        if(this.Personelid!=null && this.Personelid!=""){
          
            let KayitKontrol = this.FilterRiskDeger(RiskId,this.Personelid);
            if (KayitKontrol != null) {
                KayitKontrol.Personelid=this.Personelid;
                let FormData = KayitKontrol;

                if (Islem == "Etki") {
                  this.SecilenEtki=[];
                  
                  this.SecilenEtki=this.KriterFilter(riskpuandeger)[0];
                  this.SecilenEtki.RiskId=RiskId;
                  if(RiskId!=this.SecilenOlasilik.RiskId){this.SecilenOlasilik=[];}
                  //this.SecilenOlasilik.RiskId=RiskId;
                  FormData.Etki = riskpuandeger;
                  FormData.Etkipuanid=riskpuanid;
                } else {
                  this.SecilenOlasilik=[];
                  this.SecilenOlasilik=this.KriterFilter(riskpuandeger)[0];
                  this.SecilenOlasilik.RiskId=RiskId;
                  if(RiskId!=this.SecilenEtki.RiskId){this.SecilenEtki=[];}
                  //this.SecilenEtki.RiskId=RiskId;
                  FormData.Olasilik = riskpuandeger;
                  FormData.Olasilikpuanid=riskpuanid;
                }
                FormData.Riskpuani = FormData.Olasilik * FormData.Etki
                this.Update("StrRiskDeger", FormData)

            } else {
                let FormData = {
                  Etki: 0,
                  Etkipuanid:null,
                  Olasilik: 0,
                  Olasilikpuanid:null,
                  Riskpuani: 0,
                  Riskid: RiskId,
                  Personelid: this.Personelid,
                  Birimid: Birimid,
                  Donemid: Donemid,
                  Deleted: false,
                };

                
                FormData.Riskpuani = FormData.Olasilik * FormData.Etki

                if (Islem == "Etki") {
                  FormData.Etki = riskpuandeger;
                  FormData.Olasilik="0";
                  FormData.Etkipuanid=riskpuanid;
                } else {
                  FormData.Olasilik = riskpuandeger;
                  FormData.Etki = "0";
                  FormData.Olasilikpuanid=riskpuanid;
                }



                this.Post("StrRiskDeger", FormData).then((res) => { 
                    if(res){
                      this.RiskDegerGet();
                    } 
                });
              
                
            }

        } else {

          this.$toast.error("Kullanıcı Personel Tablosunda Bulunamadı");
        }

    },

    KriterFilter(value) {

      let BaslangicDegeri = this.KriterTablosu.filter((notification) =>  notification.Baslangicdegeri <= value);
     
      let Filter = BaslangicDegeri.filter((notification) => notification.Bitisdegeri >= value);
   

      if (Filter) {
        return Filter;
      } else {
        return;
      }
    },

    RiskDegerFilter(RiskId, Donemid) {

          let Filter = this.StrRiskDeger2.filter((notification) => notification.Riskid.includes(RiskId));

          Filter = Filter.filter((notification) => notification.Donemid.includes(Donemid));

          let VeriUzunlugu = Filter.length;

          if (VeriUzunlugu > 0) {

            return Filter[0].Riskpuani;
          } else {
            return;
          }
    },
    yetki_kontrol(yetki){

        var sonuc = this.KullaniciBilgileri.indexOf(yetki);
        return sonuc;

    },

  },
  created() {

      this.Userid = store.getters.["auth/TokenUserId"] 
      this.UserEmail = store.getters.["auth/UserEMail"] 
      this.KullaniciBilgileri = store.getters.["auth/UserRolles"];


      let YetkiSorgu = this.KullaniciBilgileri.filter((item) =>
        item.includes("StrRiskDegerlendirmeIslemleri") 
      );
      if (YetkiSorgu.length != 0) this.MenuRoleKontrol = true; 


      let Filter="&Eposta="+this.UserEmail;
        if(this.UserEmail != null){
          this.ActionsFilterGet({Service:"Opersonel", Page:this.Page, Filter:Filter}).then((res) => {
            if(res){
              this.Personelid=res.Data[0].Id;
            }

          });
        }






    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsGet({"Service":"StrStratejikAmac", "Page":Page}).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.AmacIdComboBox.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Aciklama,
        });
      }
    });

    let sorgu = "&Tip=1561";
    let Tip=[];
      
      this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
   
          for(var i=0; i<res.Data.length; i++)
          {   
              if(res.Data[i].Kod==5 ) { 

                  Tip.push(res.Data[i].Id);       

              } 
             
          }

          let altsorgu="&UstIdDoluMu=false&Approval=true";

          let tipler="";

          for (var s=0; s<Tip.length; s++){

              tipler=tipler+"&TipId="+Tip[s];

          }

          altsorgu=altsorgu+tipler;
          altsorgu=altsorgu+"&Asc=Aciklama"

            this.ActionsFilterGet({"Service":"StrPerfDonem", "Page":Page,Filter:altsorgu}).then((res) => {
              let Tarih= moment(new Date()).format('YYYY-MM-DD');
              for (var i = 0; i < res.Data.length; i++) {
                if(this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <= Tarih && Tarih <= this.$options.filters.formatDate(res.Data[i].BitisTarihi)){
                    if(!res.Data[i].UstId ){
                        this.UstDonemIdComboBox.push({
                          Id: res.Data[i].Id,
                          Value: res.Data[i].Aciklama,
                        });
                    }
                }
              }
            });

          });



    this.ActionsGet({"Service":"OBirim", "Page":Page}).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.BirimIdCombobox.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].BirimAdi,
        });

        this.rightDrawer();
      }
    });
 
    this.ActionsGet({"Service":"StrRiskDegerlendirmeKriterTablosu", "Page":Page}).then((res) => {
        if(res){
            this.KriterTablosu=res.Data;          
        }

    });
    /*  if(this.yetki_kontrol('StrRiskDegerlendirmeIslemleri')>=0){
        this.ActionsFilterGet({
        Service:
          this.$config.API_ACCOUNT_URL + "Account/get-users-in-role",
        Page: this.PageToplu,
        Filter: "&role=" + "StrRiskOylamaIslemleri",
      }).then((res) => {
          for(var Data in res.Data){
            let Filter = "&Eposta=" + res.Data[Data].Email + "&DefaultBirimId=" + this.Filter.BirimId;
            this.ActionsFilterGet({
              Service: "OPersonel",
              Page: this.PageToplu,
              Filter: Filter,
            }).then((res) => {
              this.RiskOylamaBirimYetkiliPersonel.push(res.Data[0].Id);
            }); 
          }
      });
      } */
 
  },

 
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" /> 
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <b-dropdown variant="success"  class="btn  btn-rounded mb-2 me-2">
                        <template v-slot:button-content> <i class="mdi mdi-file-export-outline me-1"></i>
                        {{ $t("StrRiskDeger.Page.ExceleAktar") }} <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <b-dropdown-item href="javascript: void(0);">{{ $t("StrRiskDeger.Page.RiskRaporuOnemDerecesineGore") }}</b-dropdown-item>  
                        <b-dropdown-item href="javascript: void(0);">{{ $t("StrRiskDeger.Page.RiskOylamaRaporu") }}</b-dropdown-item>  
                        <b-dropdown-item href="javascript: void(0);">{{ $t("StrRiskDeger.Page.RiskKayitFormu") }}</b-dropdown-item>  
                    </b-dropdown>
                    <button
                      type="button"
                      class="btn btn-secondary btn-rounded mb-2 me-2"
                      @click="rightDrawer"
                    >
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("StrRiskDeger.Page.Filtreleme") }}
                    </button>
                  </div>
                </div>
              </div>
              

              <div class="table-responsive" v-if="this.RiskPuanlar">
                <table class="table table-striped table-bordered mb-0" >
                  <thead class="table-light">
                    <tr>
                      <th colspan="2">
                        {{ $t("StrRiskDeger.Table.Baslik") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                       
                        <p>
                          <strong>{{
                            $t("StrRiskDeger.Table.EtkikBaslik")
                          }}</strong
                          ><br />
                          <span>{{ $t("StrRiskDeger.Table.EtkiContent") }}</span
                          ><br />
                          <span>{{
                            $t("StrRiskDeger.Table.EtkiContent2")
                          }}</span
                          ><br />
                          <span>{{
                            $t("StrRiskDeger.Table.EtkiContent3")
                          }}</span
                          ><br />
                        </p>
                      </td>
                      <td>
                   

                        <p>
                          <strong>{{
                            $t("StrRiskDeger.Table.OlasilikBaslik")
                          }}</strong
                          ><br />
                          <span>{{
                            $t("StrRiskDeger.Table.OlasilikContent")
                          }}</span
                          ><br />
                          <span>{{
                            $t("StrRiskDeger.Table.OlasilikContent2")
                          }}</span
                          ><br />
                          <span>{{
                            $t("StrRiskDeger.Table.OlasilikContent3")
                          }}</span
                          ><br />
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />

                
                <table class="table table-striped table-bordered mb-0" v-if="TableData!=[] && TableData.length > 0">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ $t("StrRiskDeger.AddEdit.BaslikTespitEdilenRisk") }}
                      </th>
                      <th scope="col" v-if="EskiDonem.length > 0" style="text-align:center;">
                        {{ EskiDonem[0].Aciklama }} {{ $t("StrRiskDeger.AddEdit.BirOncekiYilRiskPuani") }}
                      </th>
                      <th scope="col" style="text-align:center;">
                        {{ $t("StrRiskDeger.AddEdit.BaslikEtki") }}
                      </th>
                      <th scope="col" style="text-align:center;">
                        {{ $t("StrRiskDeger.AddEdit.BaslikOlasilik") }}
                      </th>
                      <th style="text-align:center;">
                        {{ $t("StrRiskDeger.AddEdit.Islem") }}
                      </th>
                      <th style="text-align:center;">
                        {{ $t("StrRiskDeger.AddEdit.Degerlendir") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template   v-for="TableDataVerileri in TableData">
                    <tr      
                      :key="TableDataVerileri.Id"
                    >
                      <td style="width:50%">{{ TableDataVerileri.Risk }}</td>
                      <td style="text-align: center;" v-if="EskiDonem.length > 0">
                        {{ TableDataVerileri.BirOncekiDonemPuan }}
    
                              </td>
                      <td style="width:15%">

                              
                        <select v-if="new Date(Filter.BaslamaTarihi) < bugun && 
                              new Date(Filter.BitisTarihi) > bugun"
                          class="form-select"
                          type="text"
                          @change="
                            RiskDegerGiris(
                              TableDataVerileri.Id,
                              $event.target.value,
                              'Etki',
                              Filter.BirimId,
                              Filter.DonemId
                          
                            )
                          "
                        >
                          <option value="">Seçiniz</option>
                          <option
                            v-for="veri in TableDataVerileri.RiskPuanlar"
                            :key="veri.Id"
                            :value="JSON.stringify(veri)"
                            :selected="
                              veri.Deger == FilterRiskDegerEtki(TableDataVerileri.Id)
                            "
                          >
                            {{ veri.Deger }}
                          </option>
                        </select>

                        <span v-else>
                          {{ FilterRiskDegerEtki(TableDataVerileri.Id) }}
                        </span>



                      </td>

                      <td style="width:15%">
                     
                        <select  v-if="new Date(Filter.BaslamaTarihi) < bugun &&  new Date(Filter.BitisTarihi) > bugun"
                          class="form-select"
                          type="text"
                          @change="
                            RiskDegerGiris(
                              TableDataVerileri.Id,
                              $event.target.value,
                              'Olasilik',
                              Filter.BirimId,
                              Filter.Donemid
                            )
                          "
                        >
                          <option value="">Seçiniz {{ GeciciVeri }}</option>
                          <option
                            v-for="veri in TableDataVerileri.RiskPuanlar"
                            :key="veri.Id"
                            :value="JSON.stringify(veri)"
                            :selected="
                              veri.Deger == FilterRiskDegerOlasilik(TableDataVerileri.Id)
                            "
                            @change = Get()
                          >
                            {{ veri.Deger }}
                          </option>
                        </select>
                        <span v-else>
                          {{ FilterRiskDegerOlasilik(TableDataVerileri.Id) }}
                        </span>
                        
                            
                      </td>
                      <td>
                        <b-button-group>
                          <b-button variant="danger" @click="Delete('StrRiskDeger', FilterRiskDeger(TableDataVerileri.Id,Personelid).Id),Yenile()"><i class="fas fa-trash-alt"></i></b-button>
                        </b-button-group>
                      </td>
                      <td style="width:160px">
                        <span v-if="RiskDegerFilter(TableDataVerileri.Id, Filter.DonemId) && 
                        ( yetki_kontrol('StrRiskDegerlendirmeIslemleri')>=0 
                        || yetki_kontrol('StrAdmin')>=0  || yetki_kontrol('SuperAdmin')>=0)" 
                        
                      v-b-modal.StrRiskGiris @click="(DataUpdate = TableDataVerileri), (AddEdit = 'Edit'), 
                      (AltDonem = Filter.DonemId),(Donem = Filter.UstDonemId),(sayac=sayac+1)">
                        <b-button class="mx-2" variant="outline-info"><i class="bx bx-cog bx-spin"></i> 
                          {{ $t("StrRiskler.Table.DegerlendirButton") }}
                        </b-button>
                        </span>
                        
                      </td>
                    </tr>
                    <tr v-if="TableDataVerileri.Id==SecilenEtki.RiskId || TableDataVerileri.Id==SecilenOlasilik.RiskId" 
                    :key="TableDataVerileri.Id">
                      <td colspan="1">
                        <table  class="table table-striped table-bordered mb-0">
                          <thead class="table-light">
                          <tr> 
                            <th>Risk Aralığı</th>
                            <th>Strateji</th>
                            <th>Faaliyet / Süreçler</th>
                            <th>Mali</th>
                            <th>Mevzuata Uyum</th>
                          </tr>
                        </thead>
                          <tr> <td> {{ SecilenEtki.Aralik }}</td>
                            <td> {{ SecilenEtki.Etkistrateji }}</td>
                            <td>{{ SecilenEtki.Etkifaaliyetsurec }}</td>
                            <td>{{ SecilenEtki.Etkimali }}</td>
                            <td>{{ SecilenEtki.Etkimevzuatauyum }}</td>
                          </tr>
                        </table>
                       
                      
                      </td>
                      <td colspan="4">
                        <table  class="table table-striped table-bordered mb-0">
                        <thead>
                          <tr> 
                            <th>Risk Aralığı</th>
                            <th>Olasılık</th>                          
                          </tr>
                          </thead>
                          <tr> <td> {{ SecilenOlasilik.Aralik }}</td>
                            <td> {{ SecilenOlasilik.Olasilik }}</td>
                            
                          </tr>
                        </table>
                  
                      </td>

                    </tr>

                  </template>

                  </tbody>
                </table>
     
                
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit3 :Id="DataUpdate" :AddEdit="AddEdit" :AltDonem="AltDonem" :Donem="Donem"
      :BirimId="Filter.BirimId" :Sayac="sayac" @TableUpdate="FilterGet()"  />

      <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >  
        <div style="width: 400px;" v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrRiskDeger.Filtreleme.Title") }}
            </h5>
          </div>
          <div>
            {{ $t("StrRiskDeger.Filtreleme.Content") }}
            <br>
            <br>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Risktipi',
                  Field: 'combobox',
                  FieldTitle: $t('StrRiskler.Filtreleme.Risktipi'),
                  ComboDataArray: FormDataType.Risktipi.ComboDataArray,
                }"
                :Value="Filter.Risktipi"
                :v="$v.Filter.Risktipi"
                @input="(Filter.Risktipi = $event)"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'UstDonemId',
                  Field: 'combobox',
                  FieldTitle: $t('StrRiskDeger.Filtreleme.UstDonemId'),
                  ComboDataArray: UstDonemIdComboBox,
                }"
                :Value="Filter.UstDonemId"
                :v="$v.Filter.UstDonemId"
                @input="Filter.UstDonemId = $event,DonemSec()"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'DonemId',
                  Field: 'combobox',
                  FieldTitle: $t('StrRiskDeger.Filtreleme.DonemId'),
                  ComboDataArray: DonemIdComboBox,
                }"
                :Value="Filter.DonemId"
                :v="$v.Filter.DonemId"
                @input="Filter.DonemId = $event, BirOncekiDonem(),DonemBaslamaTarihi($event)"
            
              />
            </div>
           
            <div class="mb-3">

              <b-form-group
                  class="mb-2"
                  id="birimler"
                  :label= "$t('StrRiskDeger.Filtreleme.BirimId')"
                  label-for="text"
                >
                  <BirimSecimi
                    :title_position="'mb-3'"
                    :selected="Filter.BirimId"
                    :labels_lg="'3'"  
                    :YetkiKontrol="1"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="Filter.BirimId=$event"
                  />
              </b-form-group>


            </div>
            <b-button
              @click="FilterGet(),rightDrawer()"
              class="btn btn-primary"
              variant="primary"
              >{{ $t("StrRiskDeger.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>

    </Layout>
  </Loader>
</template>
